import Api from "@/api/index";
import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/components/alerts/alert";
import AuthenticationService from "@/services/AuthenticationService";

const subjects = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    loading: false,
    queryParam: {},
    modalCreate: false,
    actions: "",
    form: {},
    count: "0",
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
    count(state) {
      return state.count;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
  },
  actions: {
    async getCount({ commit, state }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("backoffice/subjects/count/all")
        .then(({ data }) => {
          state.count = data;
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_DATAS", error.data);
        });
    },
    onRefresh({ state }) {
      store.dispatch("subjects/paginate", state.queryParam);
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("backoffice/subjects/page", payload).then(
        ({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        }
      );
    },
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("backoffice/subjects")
        .then(({ data }) => {
          commit("SET_ALL", data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_", error.data);
        });
    },
    onAction({ commit, state }, payload) {
      state.actions = payload[1];
      if (payload[1] === "Create") {
        state.form = {};
        commit("SET_MODAL_CREATE", true);
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "Update") {
        state.form = payload[0];
        commit("SET_MODAL_CREATE", true);
      }
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `subjects/${payload[1]}`);
    },
    async Create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.post("backoffice/subjects", payload)
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("subjects/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async Update({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.put(
        "backoffice/subjects/" + state.form.mata_pelajaran_id,
        payload
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("subjects/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default subjects;
